const MODE = (process.env.REACT_APP_PEOPLE_MODULE_MODE || "both").toLowerCase();

const VALID_MODES = new Set(["people", "team", "both"]);
export const PEOPLE_MODULE_MODE = VALID_MODES.has(MODE) ? MODE : "both";

export const isPeopleModuleEnabled =
  PEOPLE_MODULE_MODE === "people" || PEOPLE_MODULE_MODE === "both";

export const isLegacyTeamManagementEnabled =
  PEOPLE_MODULE_MODE === "team" || PEOPLE_MODULE_MODE === "both";

export const PEOPLE_HOME_PATH = "/people/customers";
export const LEGACY_TEAM_HOME_PATH = "/teamsection";

export function getTeamManagementHomePath() {
  return isLegacyTeamManagementEnabled
    ? LEGACY_TEAM_HOME_PATH
    : PEOPLE_HOME_PATH;
}

const LEGACY_SETTINGS_FLAG = (
  process.env.REACT_APP_LEGACY_SETTINGS_ENABLED || "false"
).toLowerCase();

export const isLegacySettingsEnabled =
  LEGACY_SETTINGS_FLAG === "true" || LEGACY_SETTINGS_FLAG === "1";

export const SETTINGS_HOME_PATH = "/settings/personal/account-security";

export function isNewSettingsPath(pathname) {
  return /\/settings\/(personal|admin)(\/|$)/.test(pathname);
}

const LEGACY_TICKETS_FLAG = (
  process.env.REACT_APP_LEGACY_TICKETS_ENABLED || "false"
).toLowerCase();

export const isLegacyTicketsEnabled =
  LEGACY_TICKETS_FLAG === "true" || LEGACY_TICKETS_FLAG === "1";

export const TICKETS_V2_PATH = "/tickets";
export const LEGACY_TICKETS_PATH = "/ticketsection";
export const TICKETS_HOME_PATH = isLegacyTicketsEnabled
  ? LEGACY_TICKETS_PATH
  : TICKETS_V2_PATH;

// Header icons — default off (moved to sidebar). Set true to show in header again.
const HEADER_SEARCH_FLAG = (
  process.env.REACT_APP_HEADER_SEARCH_ENABLED || "false"
).toLowerCase();

export const isHeaderSearchEnabled =
  HEADER_SEARCH_FLAG === "true" || HEADER_SEARCH_FLAG === "1";

const HEADER_NOTIFICATION_BELL_FLAG = (
  process.env.REACT_APP_HEADER_NOTIFICATION_BELL_ENABLED || "false"
).toLowerCase();

export const isHeaderNotificationBellEnabled =
  HEADER_NOTIFICATION_BELL_FLAG === "true" ||
  HEADER_NOTIFICATION_BELL_FLAG === "1";

// Inline page title next to sidebar toggle — default on (Application V2).
// Set false to hide header titles and restore legacy in-page titles.
const HEADER_INLINE_PAGE_TITLE_FLAG = (
  process.env.REACT_APP_HEADER_INLINE_PAGE_TITLE_ENABLED || "true"
).toLowerCase();

export const isHeaderInlinePageTitleEnabled =
  HEADER_INLINE_PAGE_TITLE_FLAG === "true" ||
  HEADER_INLINE_PAGE_TITLE_FLAG === "1";

const LEGACY_LIVE_CHAT_FLAG = (
  process.env.REACT_APP_LEGACY_LIVE_CHAT_ENABLED || "false"
).toLowerCase();

/** When false (default), Live Chat uses ChatV2 at `/chat` and `/Live` redirects there. */
export const isLegacyLiveChatEnabled =
  LEGACY_LIVE_CHAT_FLAG === "true" || LEGACY_LIVE_CHAT_FLAG === "1";

export const LIVE_CHAT_V2_PATH = "/chat";
export const LEGACY_LIVE_CHAT_PATH = "/Live";
export const LIVE_CHAT_HOME_PATH = isLegacyLiveChatEnabled
  ? LEGACY_LIVE_CHAT_PATH
  : LIVE_CHAT_V2_PATH;
